// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"1ad614d3","373":"52ee1760","673":"1ad614d3","732":"52ee1760","815":"39f64470"}[chunkId] + ".chunk.css";
};